/**
 * Dashboard Icon Mapping
 * 
 * Maps icon names (stored in database) to Lucide React icons.
 * Add new icons here when adding new applications.
 */

import React from 'react';
import {
  Megaphone,
  Smartphone,
  Users,
  CheckSquare,
  Database,
  Ticket,
  LayoutGrid,
  Settings,
  FileText,
  BarChart3,
  Calendar,
  Mail,
  Shield,
  Truck,
  Package,
  DollarSign,
  type LucideIcon,
} from 'lucide-react';

/** Default icon size for app cards */
const ICON_SIZE = 32;

/** Icon registry - maps icon names to components */
const iconRegistry: Record<string, LucideIcon> = {
  megaphone: Megaphone,
  smartphone: Smartphone,
  users: Users,
  'check-square': CheckSquare,
  database: Database,
  ticket: Ticket,
  settings: Settings,
  'file-text': FileText,
  'bar-chart': BarChart3,
  calendar: Calendar,
  mail: Mail,
  shield: Shield,
  truck: Truck,
  package: Package,
  dollar: DollarSign,
};

/** Default icon when app icon name is not found */
const DefaultIcon = LayoutGrid;

/**
 * Gets the icon component for an app
 * @param iconName - Icon name from database
 * @returns React node with the icon
 */
export const getAppIcon = (iconName?: string | null): React.ReactNode => {
  if (!iconName) {
    return <DefaultIcon size={ICON_SIZE} />;
  }

  const IconComponent = iconRegistry[iconName];
  
  if (!IconComponent) {
    return <DefaultIcon size={ICON_SIZE} />;
  }

  return <IconComponent size={ICON_SIZE} />;
};

/**
 * List of available icon names (for admin UI)
 */
export const availableIcons = Object.keys(iconRegistry);

